import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "user-settings-property-icon"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "toggle switch w-100" }
const _hoisted_4 = { class: "switch-label mr-auto" }
const _hoisted_5 = ["id", "checked"]
const _hoisted_6 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'components-switch user-settings-property': true,
            'is-icon': _ctx.icon,
            hidden: _ctx.hidden,
        })
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.icon,
            alt: "''"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.fieldId), 1),
      _createElementVNode("input", _mergeProps({
        id: _ctx.fieldId,
        type: "checkbox",
        checked: !!_ctx.checked
      }, _ctx.$attrs, {
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.check()))
      }), null, 16, _hoisted_5),
      _createElementVNode("label", {
        class: "toggle-item static-bg-color",
        for: _ctx.fieldId
      }, null, 8, _hoisted_6)
    ])
  ], 2))
}